<div class="pagination-tile">
  <div class="pages-wrap">
    <div class="page" (click.zoneless)="goPrevPage($event)">
      <span>{{ 'Previous' | translate }}</span>
    </div>

    <ng-container *ngIf="showFirstSection">
      <div class="page bold" (click)="selectPage(1, $event)">1</div>

      <div class="page bold dots-start">...</div>
    </ng-container>

    <ng-container *ngFor="let page of pagesList">
      <div class="page bold" (click)="selectPage(page, $event)" [class.active]="page === currentPage">
        {{ page }}
      </div>
    </ng-container>

    <ng-container *ngIf="showLastSection">
      <div class="page bold dots-end">...</div>

      <div class="page bold" (click)="selectPage(pageCount, $event)">
        {{ pageCount }}
      </div>
    </ng-container>

    <div class="page" (click.zoneless)="goNextPage($event)">
      <span>{{ 'Next' | translate }}</span>
    </div>
  </div>
</div>
